<template>
  <v-container fluid class="gridEditor">
    <div class="headPanel">
      <div class="formControl">
        <v-select
          dense
          outlined
          :items="formsList"
          v-model="selectedForm"
          label="Select form"
          full-width
        ></v-select>
      </div>
      <div v-if="selectedForm">
        <div v-if="currentPlanId" class="">
          <v-checkbox
            v-model="planLevel"
            label="Plan level"
            class="mt-0 pt-0 planLevelCheckbox"
          ></v-checkbox>
          <span v-if="planLevel" class="currentPlanName">{{ currentPlanName }}</span>
        </div>
        <div v-else>
          <v-alert type="info" outlined dense>
            Please, select a plan first to view the plan-level grid
          </v-alert>
        </div>
      </div>
    </div>
    <div v-if="selectedForm" class="builderTable">
      <v-data-table
        :headers="headers"
        :items="gridHeaders"
        :loading="loading"
        :search="search"
        :items-per-page="-1"
        @click:row="editFieldRow"
        dense
      >
        <template v-slot:top>
          <div class="tableToolbar">
            <v-dialog persistent v-model="isDialogShown" max-width="750">
              <!-- <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  :disabled="loading"
                  class="mb-2"
                  @click="editFieldRow(defaultItem)"
                >
                  Add field
                </v-btn>
              </template> -->

              <v-card>
                <v-card-title>
                  <span class="text-h5">{{ dialogTitle }}</span>
                </v-card-title>

                <v-card-text v-if="editedItem">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.HeaderText"
                          label="Header text"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.ColumnOrder"
                          label="Column order"
                          type="number"
                          :min="0"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-checkbox
                          v-model="editedItem.Visible"
                          label="Visible"
                          class="visibilityCheckbox"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.FieldFormat"
                          label="Field format"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-select
                          v-model="editedItem.Align"
                          :items="alignTypeList"
                          label="Align"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="4"> </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" outlined @click="cancelSave"> Cancel </v-btn>
                  <v-btn color="primary" depressed @click="saveItem"> Ok </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              class="mb-4 search"
              single-line
              hide-details
            ></v-text-field>
          </div>
        </template>
      </v-data-table>
    </div>
    <!-- <div v-if="showFormButtons"> -->
    <v-footer
      v-if="isGridHeadersExists && showFormButtons"
      padless
      fixed
      outlined
      class="footerBtnContainer"
      elevation="3"
    >
      <div class="btnContainer">
        <v-btn color="primary" depressed @click="onSaveGridHeaders" :disabled="!isSaveAvailable">
          Save grid headers
        </v-btn>
      </div>
    </v-footer>
    <!-- </div> -->
  </v-container>
</template>

<script>
export default {
  name: 'GridEditor',
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      planLevel: false,
      formsList: [],
      selectedForm: null,
      search: '',
      headers: [
        { text: 'Data Field', value: 'Datafield' },
        { text: 'Header text', value: 'HeaderText' },
        { text: 'Column order', value: 'ColumnOrder' },
        { text: 'Visible', value: 'Visible' },
        { text: 'Alignment', value: 'Align', filterable: false },
        { text: 'Field format', value: 'FieldFormat', filterable: false },
      ],
      gridHeaders: [],
      isDialogShown: false,

      editedItem: null,
      editedIndex: -1,
      isDialogDeleteShown: false,
      isSaveAvailable: false,
      plansList: [],
      alignTypeList: ['Left', 'Right', 'Center'],
    };
  },
  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    currentPlanName() {
      if (this.currentPlanId && this.plansList && this.plansList.length > 0) {
        const plan = this.plansList.find((x) => {
          return x.Id == this.currentPlanId;
        });
        if (plan) {
          return plan.ShortName;
        }
      }
      return '';
    },
    dialogTitle() {
      return this.editedIndex === -1 ? 'Add new row' : 'Edit field';
    },
    isGridHeadersExists() {
      return this.gridHeaders && this.gridHeaders.length > 0;
    },
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },

  watch: {
    selectedForm() {
      this.getGridHeaders();
    },
    planLevel() {
      this.getGridHeaders();
    },
  },
  created() {
    this.getFormsList();
    this.getPlansList();
  },
  methods: {
    resetEdited() {
      this.editedItem = null;
      this.editedIndex = -1;
      this.isDialogShown = false;
    },
    editFieldRow(item) {
      if (!this.showFormButtons) return;
      this.editedIndex = this.gridHeaders.indexOf(item);
      this.editedItem = { ...item };
      this.isDialogShown = true;
    },
    saveItem() {
      const item = this.gridHeaders[this.editedIndex];
      this.isSaveAvailable =
        this.isSaveAvailable ||
        item.FieldFormat != this.editedItem.FieldFormat ||
        item.ColumnOrder != this.editedItem.ColumnOrder ||
        item.HeaderText != this.editedItem.HeaderText ||
        item.Align != this.editedItem.Align ||
        item.Visible != this.editedItem.Visible;

      item.FieldFormat = this.editedItem.FieldFormat;
      item.ColumnOrder = this.editedItem.ColumnOrder;
      item.HeaderText = this.editedItem.HeaderText;
      item.Align = this.editedItem.Align;
      item.Visible = this.editedItem.Visible;

      this.resetEdited();
    },
    cancelSave() {
      this.resetEdited();
    },
    onSaveGridHeaders() {
      if (this.isSaveAvailable) this.updateGridHeaders();
    },
    async getFormsList() {
      this.loading = true;
      try {
        const response = await this.$api.get('/datadictionary/GetGridList');

        this.formsList = response.data;
      } catch (err) {
        console.log(err.message);
      } finally {
        this.loading = false;
      }
    },

    async getGridHeaders() {
      this.loading = true;
      this.isSaveAvailable = false;
      try {
        const planId = this.planLevel ? this.currentPlanId : 0;
        const response = await this.$api.get(
          '/datadictionary/GetGridHeaders?planId=' + planId + '&formName=' + this.selectedForm
        );

        this.gridHeaders = response.data;
      } catch (err) {
        console.log(err.message);
      } finally {
        this.loading = false;
      }
    },

    async updateGridHeaders() {
      this.loading = true;
      const planId = this.planLevel ? this.currentPlanId : 0;
      try {
        const model = {
          FormName: this.selectedForm,
          PlanId: planId,
          Fields: this.gridHeaders,
        };
        await this.$api.post('/datadictionary/UpdateGridHeaders', model);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Saved!',
        });
        this.getGridHeaders();
        this.isSaveAvailable = false;
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loading = false;
      }
    },
    async getPlansList() {
      try {
        const response = await this.$api.get('/plans/getplanlist');

        if (!response.data || !response.data.length) {
          const msg = 'Unable to load plans';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        this.plansList = response.data;
      } catch (error) {
        console.log(error.message);
      }
    },
  },
};
</script>

<style scoped>
.headPanel {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 20px 0 20px;
}
.headPanel .formControl {
  width: 371px;
}
.headPanel .planLevelCheckbox {
  display: inline-block;
  margin-right: 20px;
  vertical-align: top;
}

.headPanel .currentPlanName {
  background-color: #4a1cd426;
  padding: 8px;
  color: #4a1cd4;
}

.headPanel > div {
  margin-right: 30px;
}
.headPanel .v-alert {
  padding-top: 5px;
  padding-bottom: 5px;
  margin-top: -10px;
}
.v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
.builderTable {
  padding: 0 20px 25px;
}
.search {
  max-width: 475px;
}
.tableToolbar {
  display: flex;
  align-items: baseline;
  padding-bottom: 4px;
}

.visibilityCheckbox {
  margin-top: 15px;
}
</style>

<style lang="scss">
.footerBtnContainer {
  .btnContainer {
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 12px;
    margin-top: 12px;
    width: 100%;
    text-align: right;
  }
}

.v-footer {
  padding: 0px;
}

.gridEditor {
  .theme--light.v-data-table tbody tr.v-data-table__selected {
    background: #4a1cd41f !important;
  }

  .theme--light.v-data-table tbody tr {
    cursor: pointer;
  }
}
</style>
